import { render, staticRenderFns } from "./CookiesDetail.vue?vue&type=template&id=27c01258&scoped=true&"
import script from "./CookiesDetail.vue?vue&type=script&lang=js&"
export * from "./CookiesDetail.vue?vue&type=script&lang=js&"
import style1 from "./CookiesDetail.vue?vue&type=style&index=1&id=27c01258&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c01258",
  null
  
)

export default component.exports